/** Minimum field length required for trigram blind-index search */
export const MIN_SEARCH_LENGTH = 3;
